import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { UserTransaction, UserTransactionDetail, ParamPaymentChannelInstructions, PaymentChannelInstructions } from 'src/app/models/receivable';
import { UserTransactionStatus } from 'src/app/models/account';
import { ReceivableService } from 'src/app/services/receivable.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PaymentService } from 'src/app/services/payment.service';
import { AlertComponent } from 'src/app/alert/alert.component';
import { ClipboardService } from 'ngx-clipboard';

declare var $: any;

@Component({
  selector: 'app-process-payment',
  templateUrl: './process-payment.component.html',
  styleUrls: ['./process-payment.component.css']
})
export class ProcessPaymentComponent implements OnInit {
  transactionData: any;
  public transaction: UserTransaction;
  firstDetail: UserTransactionDetail;
  public detail: UserTransactionDetail;
  paramPaymentChannelInstructions: ParamPaymentChannelInstructions = new ParamPaymentChannelInstructions();
  public paymentChannelInstructions: PaymentChannelInstructions[] = [];
  isLoading = false;
  copyClicked = false;
  @ViewChild('alertComponent') alertModal: AlertComponent;
  message = '';
  ovo = false;
  private timer;

  public hour: number;
  public minute: number;
  public second: number;

  get getStatus() { return UserTransactionStatus; }

  constructor(
    public receivableService: ReceivableService,
    private paymentService: PaymentService,
    private clipboardService: ClipboardService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.isLoading = true;

    //Data passing
    this.transactionData = this.route.snapshot.paramMap.get('data');
    this.transaction = JSON.parse(atob(this.transactionData));

    if (this.transaction) {
      this.receivableService.getUserTransactionDetail(this.transaction.id,
        (data) => {
          this.firstDetail = data;

          this.getPaymentChannelInstructions();
          this.applyJqueryScript();
        },
        (err) => {
          console.log(err);
        });
    }

    this.getTransactionDetail();
    this.timer = setInterval(() => { this.getTransactionDetail(); }, 10000);
  }

  applyJqueryScript() {
    const that = this;
    const target_date = new Date(that.firstDetail.expiredIn).getTime();

    const utc_now = that.firstDetail.utcNow.toString().split('T');
    const utc_now_date = utc_now[0];
    const utc_now_time = utc_now[1].split('.');
    const currentDate = new Date(utc_now_date + ' ' + utc_now_time[0]);

    let hours: any;
    let minutes: any;
    let seconds: any;

    setInterval(function () {
      currentDate.setSeconds(currentDate.getSeconds() + 1);

      const current_date = currentDate.getTime();
      let seconds_left = (target_date - current_date) / 1000;

      hours = seconds_left / 3600;
      seconds_left = seconds_left % 3600;

      minutes = seconds_left / 60;
      seconds = seconds_left % 60;

      that.hour = parseInt(hours);
      that.minute = parseInt(minutes);
      that.second = parseInt(seconds);

    }, 1000);
  }

  getTransactionDetail() {
    if (this.transactionData != null) {
      try {
        if (this.transaction) {
          this.receivableService.getUserTransactionDetail(this.transaction.id,
            (data) => {
              this.detail = data;

              if (this.detail.status !== this.getStatus.Waiting) {
                clearInterval(this.timer);
                $('#notif').modal('hide');
                this.router.navigate([`/receivable/detail-payment/${btoa(JSON.stringify(this.transaction))}`]);
              }

              if (this.detail.transferDescription === 'OVO Payment') {
                this.ovo = true;
              }

              // hour +7
              const expiredDate = new Date(this.detail.expiredIn);
              expiredDate.setHours(expiredDate.getHours() + 7);
              this.detail.expiredIn = expiredDate;

              this.isLoading = false;
            },
            (err) => {
              console.log(err);
            });
        }
      } catch {
        this.transaction = null;
      }
    }

    if (this.detail === null) {
      this.router.navigate(['/receivable']);
    }
  }

  getPaymentChannelInstructions() {
    this.paramPaymentChannelInstructions.PaymentChannelId = this.firstDetail.paymentChannelId;
    this.paramPaymentChannelInstructions.VaNumber = this.firstDetail.virtualAccountNumber;

    this.receivableService.getPaymentChannelInstructions(this.paramPaymentChannelInstructions,
      (data) => {
        this.paymentChannelInstructions = data;
      },
      (err) => {
        console.log(err);
      });
  }

  copyVA() {
    this.clipboardService.copyFromContent(this.detail.virtualAccountNumber);
    this.copyClicked = true;
    setTimeout(() => { this.copyClicked = false; }, 3000);
  }

  cancelPayment() {
    this.paymentService.cancelPayment(this.transaction.id, (response) => {
      const { alert } = response;
      if (alert.code === 200) {
        this.message = 'Pembatalan Berhasil!';
        $('#notif').modal('show');
        clearInterval(this.timer);
        return;
      } else {
        this.message = alert.message;
        $('#notif').modal('show');
      }
    }, (err) => {
      this.message = err;
      $('#notif').modal('show');
    });
  }

  handleOKNotif() {
    $('#notif').modal('hide');
    this.router.navigate([`/receivable/detail-payment/${btoa(JSON.stringify(this.transaction))}`]);
  }
}
